/**
 * Values for health value defined in the server
 */
module.exports = {
  SERVER_HEALTHY: 0,
  SERVER_UNHEALTHY: 1,
  SERVER_WARN: 2,
  SERVER_NA: 3
};



// WEBPACK FOOTER //
// ./src/js/constants/UnitHealthTypes.js